import React from 'react';
import './boardModules.scss';

const IMAGES = '/images/traceability';
const PINS = [0, 1, 2, 3, 4, 5];

/**
 * La ilustración del modal de puerto incorrecto: una placa vista de canto con
 * cuatro puertos, la ficha enchufada en el tercero y la marca de error. Es fija
 * -- no depende de la placa ni del puerto --, y está armada como en el diseño:
 * cajas con gradientes y los SVG que no se pueden hacer con CSS.
 */
const PortsIllustration = () => (
  <div className="portsIllustration" aria-hidden="true">
    <div className="stage">
      <div className="board-surface" />
      <div className="board-edge" />
      <div className="error-glow" />
      {[0, 1, 2, 3].map((index) => (
        <div key={index} className={`port port-${index}`}>
          <div className="port-front" />
          <div className="port-top" />
          <img className="port-mouth" src={`${IMAGES}/port-${index === 3 ? 'bocaRj1' : 'bocaRj'}.svg`} alt="" />
          {PINS.map((pin) => <div key={pin} className={`port-pin pin-${pin}`} />)}
        </div>
      ))}
      <div className="plug">
        <img className="plug-body" src={`${IMAGES}/port-union.svg`} alt="" />
        <div className="plug-outlet" />
        <img className="plug-cable" src={`${IMAGES}/port-cablePlano.svg`} alt="" />
        <img className="plug-cable-shine" src={`${IMAGES}/port-brilloCable.svg`} alt="" />
        <div className="plug-shine plug-shine-1" />
        <div className="plug-shine plug-shine-2" />
      </div>
      <div className="error-frame" />
      <img className="error-badge" src={`${IMAGES}/port-errorFondo.svg`} alt="" />
      <img className="error-x" src={`${IMAGES}/port-errorX.svg`} alt="" />
    </div>
  </div>
);

export default PortsIllustration;
